import { CONTACT_SKIP_ACW } from 'lib/common/constants/contactAttributes';

import getContactAttributes from '../getContactAttributes';

const STRING_TRUE = 'true';

export default function isContactSkipAcw(contact: connect.Contact): boolean {
  const { [CONTACT_SKIP_ACW]: skipAcw } = getContactAttributes({ contact }, CONTACT_SKIP_ACW);

  return skipAcw?.toLowerCase() === STRING_TRUE;
}
